<template>
  <!-- 状态更新 -->
  <van-dialog
    v-model="visible"
    :showConfirmButton="false"
    style="box-shadow: 0px -2px 5px 0px rgba(0, 0, 0, 0.1); border-radius: 8px"
    popup-transition="popup-fade"
  >
    <div class="alert_bg">
      <div class="bind_close" @click.stop="close" />
      <div class="center">
        <div class="login_logo" />
      </div>

      <div
        :class="
          mobileDesc
            ? 'input_bg_err'
            : mobileFocus
            ? 'input_bg_focus'
            : 'input_bg'
        "
      >
        <span class="input_left">+86</span>
        <div class="input_arrow" />
        <input
          :class="mobileDesc ? 'input_content_error' : 'input_content'"
          v-model="mobile"
          placeholder="请输入手机号"
          @blur="checkMobile"
          @focus="mobileFocus = true"
          style="outline: none; -webkit-appearance: none"
        />
      </div>
      <div v-show="mobileDesc" class="input_error">{{ mobileDesc }}</div>

      <div
        v-if="loginType == 2"
        :class="
          passwordDesc
            ? 'input_bg_err'
            : passwordFocus
            ? 'input_bg_focus'
            : 'input_bg'
        "
      >
        <input
          :class="mobileDesc ? 'input_content_error' : 'input_content'"
          :type="eyeClose ? 'password' : ''"
          v-model="password"
          placeholder="请输入密码"
          style="outline: none; -webkit-appearance: none"
          @blur="checkPassword"
          @focus="passwordFocus = true"
        />
        <div @click="eyeClose = !eyeClose" style="padding: 10px 5px">
          <img
            style="height: 17px; width: 20px; padding-top: 5px"
            :src="
              eyeClose
                ? require('@/assets/images/login_eye_close.png')
                : require('@/assets/images/login_eye_open.png')
            "
          />
        </div>
      </div>
      <div v-if="loginType == 2" v-show="passwordDesc" class="input_error">
        {{ passwordDesc }}
      </div>

      <div
        v-if="loginType == 1"
        :class="
          codeDesc ? 'input_bg_err' : codeFocus ? 'input_bg_focus' : 'input_bg'
        "
      >
        <input
          :class="mobileDesc ? 'input_content_error' : 'input_content'"
          v-model="code"
          style="outline: none; -webkit-appearance: none"
          placeholder="填写验证码"
          @blur="checkSms"
          @focus="codeFocus = true"
        />
        <button
          :disabled="smsBtnDesc !== '发送'"
          @click="geSms"
          class="input_btn"
        >
          {{ smsBtnDesc }}
        </button>
      </div>
      <div v-if="loginType == 1" v-show="codeDesc" class="input_error">
        {{ codeDesc }}
      </div>
      <span v-show="errmsg" style="color: rgb(255, 85, 81); font-size: 14px">{{
        errmsg
      }}</span>
      <button class="login_btn" @click="submitCheckSms">
        {{ loginType === '1' ? '登录/注册' : '登录' }}
      </button>

      <span v-if="showCheckMsg" class="login_type" @click="changeLoginType">
        {{ loginType === '1' ? '密码登录' : '短信注册/登录' }}
      </span>

      <div class="login_desc">
        <div>
          <van-checkbox
            class="agreeSub"
            style="display: inline-block; vertical-align: top"
            v-model="agreeSub"
          ></van-checkbox>
          同意禾蛙
          <span class="login_agreement" @click="jumpToAgreement">
            《用户服务协议》
          </span>
          <span class="login_agreement" @click="jumpToPrivacy">
            《隐私协议》
          </span>
        </div>
      </div>
    </div>
  </van-dialog>
</template>
<script>
import { Toast } from 'vant'
import { mapState, mapMutations, mapActions } from 'vuex'
import * as sysTool from '@/utils/systemTool'
import Cookies from 'js-cookie'
import JSEncrypt from 'jsencrypt'
export default {
  props: {
    // type 1 更换密码 2 找回密码 3 更换手机 4.注册猎企 5 更换邮箱 6.更换管理员 7.成员移除与交接 8.微信绑定-个人中心 10 登录验证码 20 未知
    visible: {
      required: true,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      mobile: '',
      mobileDesc: '',
      mobileFocus: false,
      code: '',
      codeDesc: '',
      codeFocus: false,
      password: '',
      passwordDesc: '',
      passwordFocus: false,
      smsBtnDesc: '发送',
      interval: null,
      smsCountdown: 60,
      loginType: '1',
      eyeClose: true,
      errmsgList: [
        { key: 192, value: '该微信号已绑定其他手机号，请用绑定的手机号登录' },
        { key: 126, value: '该手机号已绑定其他微信号，可在PC端换绑' },
      ],
      errmsg: '',
      showCheckMsg: true,
      agreeSub: false,
      antiShakeTimer: null, //防抖
    }
  },
  mounted() {
    this.agreeSub = Boolean(localStorage.getItem('agreeSub')) || false
    this.initCountDown()
    this.queryAgreementUrl({
      protocol_template_code: 'CODE002',
    })
    this.queryAgreementYsxyUrl({
      protocol_template_code: 'PRIVA001',
    })
    this.showMobile()
    let loginStatus = Cookies.get('loginStatus')
      ? JSON.parse(Cookies.get('loginStatus'))
      : ''
    if (loginStatus && loginStatus.status == 2) {
      this.showCheckMsg = false
      return
    }
  },

  beforeDestroy() {
    this.interval && clearInterval(this.interval)
  },
  computed: {
    ...mapState('index', [
      'userInfo',
      'authInfo',
      'smsTypeTime',
      'agreementInfo',
      'errorCode',
      'agreementInfoYsxy',
    ]),
  },
  watch: {
    errorCode(val) {
      let obj = this.errmsgList.find((item) => {
        return item.key == val
      })
      if (obj) {
        this.errmsg = obj.value
      }
    },

    smsCountdown(newValue, oldValue) {
      if (newValue === 0 || newValue === 60) {
        this.smsBtnDesc = '发送'
      } else {
        this.smsBtnDesc = newValue + '秒'
      }
      return newValue
    },
  },
  methods: {
    ...mapActions('index', [
      'requestGetSms',
      'requestLogin',
      'queryAgreementUrl',
      'queryAgreementYsxyUrl',
      'requestAuth',
    ]),
    ...mapMutations('index', ['setStateItem']),

    initCountDown() {
      let nowTime = new Date().getTime()
      let lastTime = this.smsTypeTime[this.type]
        ? this.smsTypeTime[this.type]
        : 0
      let rangTime = parseInt((nowTime - lastTime) / 1000)

      console.log(nowTime + '-' + lastTime + '=' + rangTime)
      if (rangTime > 60) {
        this.smsCountdown = 60
      } else {
        this.smsCountdown = 60 - rangTime
      }

      if (this.smsCountdown === 60) {
        this.smsBtnDesc = '发送'
      } else {
        this.smsBtnDesc = this.smsCountdown + '秒'
        this.startCountdown()
      }
    },
    checkSms() {
      this.codeFocus = true
      let value = this.code
      if (!value) {
        this.codeDesc = '验证码不可为空'
      }
      if (!/\d{6}/.test(value)) {
        this.codeDesc = '验证码不匹配'
      } else {
        this.codeDesc = null
      }
      this.codeFocus = false
      this.fitIos()
    },
    checkPassword() {
      this.passwordFocus = true

      let value = this.password
      if (!value) {
        this.passwordDesc = '请输入正确的密码'
      }

      if (value.length < 6 || value.length > 15) {
        this.passwordDesc = '输入密码不能小于6位大于15位'
      } else {
        this.passwordDesc = null
      }
      this.passwordFocus = false
      this.fitIos()
    },
    focusMobile() {
      this.mobileFocus = true
    },
    checkMobile() {
      let value = this.mobile

      if (!value) {
        this.mobileDesc = '请输入手机号码'
      }
      if (Number.isNaN(value)) {
        this.mobileDesc = '手机号格式有误'
      } else {
        if (
          !/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(value) &&
          this.loginType == 1
        ) {
          this.mobileDesc = '手机号格式有误'
        } else if (
          !/^1[3|4|5|6|7|8|9][0-9]\d{8}|^9\d{7}$/.test(value) &&
          this.loginType == 2
        ) {
          this.mobileDesc = '手机号格式有误'
        } else {
          this.mobileDesc = null
        }
      }
      this.mobileFocus = false
      this.fitIos()
    },
    close() {
      this.parentDialogClose()
    },
    changeLoginType() {
      let loginStatus = Cookies.get('loginStatus')
        ? JSON.parse(Cookies.get('loginStatus'))
        : ''
      if (loginStatus && loginStatus.status == 2) {
        return
      }
      this.loginType = this.loginType === '1' ? '2' : '1'
    },
    startCountdown() {
      console.log('startCountdown ' + this.smsCountdown)

      this.interval && clearInterval(this.interval)
      this.interval = setInterval(() => {
        if (this.smsCountdown > 0) {
          console.log('启动倒计时 ' + this.smsCountdown)
          this.smsCountdown = this.smsCountdown - 1
        } else {
          this.smsCountdown = 60
          this.interval && clearInterval(this.interval)
        }
      }, 1000)
    },
    cacheSmsCount() {
      let value = { ...this.smsTypeTime }
      value[this.type] = new Date().getTime()
      this.setStateItem({
        key: 'smsTypeTime',
        value: value,
      })
    },
    geSms(e) {
      console.log('click getSms')
      let target = e.target
      if (target.nodeName == 'SPAN' || target.nodeName == 'I') {
        target = e.target.parentNode
      }
      target.blur()
      this.checkMobile()

      if (this.smsBtnDesc === '发送') {
        if (!this.mobileDesc) {
          let jse = new JSEncrypt()
          //公钥
          var publicString =
            '-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArn2/OtjBRCPa4C2CxIVQ/0A4HDGDc+LDzJUNcjtQN7PLQPS0Kvv5e5IcSWUDyB7ZhIoLhnqRiQMrgaN3zA6pZsziqLf4oLTGluO8JJkP7cYJEMPNso5jTgDaa/NuZR7hRWWHjLR6nOkO3AmSXOfVUFjjrBI8GVUeiSdaGf9EPSDcRFsoxbY3kGvfeYSQwrRi4SgO8snYc+xwcHXxpyXiqIaLYoxvo7QIfFAduhpJIK4c1wPIt8HSeb1uNycHfqzw3ciWXPgq9O40lwW3ZslAQAcUddpkp01RTh9V4Thd5pgAHb+7c/PeNmulpxRC9v7lFC+ZlIL/FNHV75h6LElilwIDAQAB-----END PUBLIC KEY-----'
          jse.setPublicKey(publicString)
          this.requestGetSms({
            type: '10',
            area_code: '+86',
            mobile: this.mobile,
            sign: jse.encrypt(this.mobile) ? jse.encrypt(this.mobile) : '', // 加密内容
            cb: () => {
              // 启动倒计时
              this.startCountdown()
              this.cacheSmsCount()
            },
          })
        }
      }
    },
    jumpToAgreement() {
      this.agreementInfo &&
        window.open(this.agreementInfo.protocol_template_path)
    },
    // 隐私协议
    jumpToPrivacy() {
      this.agreementInfoYsxy &&
        window.open(this.agreementInfoYsxy.protocol_template_path)
    },
    // 跳转路由方法
    next({ key, value, name, query }) {
      this.setStateItem({
        key,
        value,
      })
      this.$router.push({
        name,
        query,
      })
    },
    submitCheckSms() {
      this.checkMobile()
      if (this.mobileDesc) {
        return
      }
      if (this.loginType === '1') {
        this.checkSms()
        if (this.codeDesc) {
          return
        }
      } else {
        this.checkPassword()
        if (this.passwordDesc) {
          return
        }
      }

      var encrypt = new JSEncrypt()
      encrypt.setPublicKey(
        'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvdidUlJKNBUbxpJSohx++NspsBfw/bFOQ6j5/miY+LRh9Fnob7Rz9i21zxDhDy0ddygontvY50jkj60lR+uRauVt+ZNsP7s839WTJd8Cx9HcbBTMzz30AdCiUj/+SGiBiNJqpjqub/YNr52/HmgCAiDEj1p9FiJAqVBG21z0FCEAPIu6GpyCv4uXy0HBIsPmrO62+x9VINsLWT5RP07ie5iMg+3fDcRuAh+wqA2RbbMIrPp6uc3STXOW+beOcDnB5JNClXUZ4vaWXGRwiumesqphTMlI0AOzgHKe7FJbaP91fgsfdARnhJdSyEQxDTE6/j3Pe4ycG74yIKZj1NlayQIDAQAB'
      )
      let securityPwd = encrypt.encrypt(this.password)

      var brower = sysTool.GetCurrentBrowser()
      var os = sysTool.GetOs() ? sysTool.GetOs() : 'MacOS'
      var edition = sysTool.getEdition()
      let user_agent = brower + ' ' + '(' + os + ';' + edition + ')'
      if (this.agreeSub) {
        localStorage.setItem('agreeSub', this.agreeSub)
        if (this.antiShakeTimer) {
          Toast('请勿频繁操作！')
          clearTimeout(this.antiShakeTimer)
        }
        this.antiShakeTimer = setTimeout(() => {
          this.requestLogin({
            login_type: this.loginType,
            no_secret: this.loginType === '1' ? '1' : '0',
            mobile: this.mobile,
            password: securityPwd,
            verification_code: this.code,
            user_agent: user_agent,
            area_code: '+86',
            type: '10',
            cb: () => {
              let data = {
                cb: () => {
                  let {
                    user_type,
                    qiyuesuo_auth_status,
                    is_grant_auth_hewa,
                    authorization_status,
                    is_email,
                  } = this.authInfo
                  this.$emit('loginResult', 1)
                  switch (this.authInfo.user_type) {
                    case 3:
                      //认证成功，不用判断是否禾蛙授权，一系列条件可以拦截到认证成功页面（有禾蛙授权功能）
                      if (qiyuesuo_auth_status == 2) {
                        //判断是否签署协议
                        if (is_grant_auth_hewa == 1) {
                          this.next({
                            name: 'SettleIn',
                          })
                          return
                        }
                        //否则跳转认证成功页面 ？？？？？
                        this.next({
                          name: 'Certification',
                          query: { status: 2 },
                        })
                        return
                        //认证失败
                      } else if (qiyuesuo_auth_status == 3) {
                        this.next({
                          name: 'Certification',
                          query: { status: 3 },
                        })
                        return
                      }
                      this.next({
                        name: 'companyEntry',
                      })
                      break
                    case 6:
                      this.next({
                        name: 'Certification',
                        query: {
                          status: 3,
                          //   msg: '5678945678'
                        },
                      })
                      break
                    default:
                      break
                  }
                },
              }
              this.requestAuth(data)
            },
          })
        }, 1500)
      } else {
        Toast('请先阅读协议并确认')
      }
    },
    parentDialogClose() {
      this.$emit('loginResult', 0)
    },
    fitIos() {
      var u = navigator.userAgent
      var flag
      var myFunction
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIOS) {
        document.body.addEventListener('focusin', () => {
          //软键盘弹起事件
          flag = true
          clearTimeout(myFunction)
        })
        document.body.addEventListener('focusout', () => {
          //软键盘关闭事件
          const scrollHeight =
            document.documentElement.scrollTop || document.body.scrollTop || 0
          window.scrollTo(0, Math.max(scrollHeight - 1, 0))
          flag = false
          if (!flag) {
            myFunction = setTimeout(function () {
              window.scrollTo({ top: 0, left: 0, behavior: 'smooth' }) //重点
              //=======当键盘收起的时候让页面回到原始位置(这里的top可以根据你们个人的需求改变，并不一定要回到页面顶部)
            }, 200)
          } else {
            return
          }
        })
      } else {
        return
      }
    },
    showMobile() {
      this.mobile = Cookies.get('userPhoneInfo')
        ? JSON.parse(Cookies.get('userPhoneInfo')).mobile
        : ''
    },
  },
}
</script>
<style scoped>
::v-deep .van-checkbox__icon {
  font-size: 16px;
}
::v-deep .van-checkbox__icon--checked .van-icon {
  color: #fff;
  background-color: #5ebfb9;
  border-color: #5ebfb9;
}
input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #e0e0e0;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #e0e0e0;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #e0e0e0;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #e0e0e0;
}
input {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5d5d5d;
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.bind_close {
  position: absolute;
  right: 13px;
  top: 13px;
  width: 20px;
  height: 20px;
  background: #ffffff url('../../assets/images/bind_close.png') no-repeat center;
  background-size: 100% 100%;
}
.login_type {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #909090;
}
.login_desc {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #909090;
  margin-top: 60px;
}
.login_agreement {
  color: #5ebfb9;
}
.alert_bg {
  width: 270px;
  background: white;
  padding: 12px 20px;
  align-items: center;
  /* box-shadow: 0px -2px 5px 0px rgba(0, 0, 0, 0.1); */
  border-radius: 8px;
}
.login_logo {
  width: 60px;
  height: 30px;
  background: #ffffff url('../../assets/images/login_logo.png') no-repeat center;
  background-size: 100% 100%;
  margin: 15px 0px;
}
.input_bg {
  width: 100%;
  height: 50px;
  background: #ffffff;
  border: 1px solid #d3d3d3;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 15px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  margin: 0.2rem 0;
}
.input_bg_focus {
  width: 100%;
  height: 50px;
  background: #ffffff;
  border: 1px solid #5ebfb9;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 15px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  margin: 0.2rem 0;
}
.input_bg_err {
  width: 100%;
  height: 50px;
  background: #ffffff;
  border: 1px solid #ff5551;

  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 15px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  margin: 0.2rem 0;
}
.input_left {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5d5d5d;
}
.input_arrow {
  display: inline;
  width: 13px;
  /* height: 4px; */
  background: #ffffff url('../../assets/images/login_arrow_bottom.png')
    no-repeat center;
  background-size: 100% 100%;
  margin: 5px;
}
.input_content {
  border: none;
  /* height: 40px; */
  width: 100%;
  font-size: 18px;
}
.input_content_error {
  border: none;
  /* height: 40px; */
  width: 100%;
  font-size: 18px;
  /* color: #FF5551; */
}
.input_error {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #ff5551;
}
:focus {
  outline-color: white;
}
.input_btn {
  /* width: 230px; */
  width: 70px;
  border: none;
  font-size: 18px;
  /* height: 16px; */
  color: #5ebfb9;
  margin: 0;
  padding: 0;
  margin-right: 0;
  background-color: white;
  font-weight: 500;
}
.login_btn {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #5ebfb9;
  color: white;
  height: 50px;
  border: none;
  border-radius: 10px;
  margin: 0.61rem 0 0.29rem;
  font-size: 18px;
  font-weight: 500;
  width: 100%;
}
input[type='“text”'],
input[type='“button”'],
input[type='“submit”'],
input[type='“reset”'],
select,
textarea,
button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 100px white inset !important;
  -moz-box-shadow: 0 0 0px 100px white inset !important;
  -ms-box-shadow: 0 0 0px 100px white inset !important;
  box-shadow: 0 0 0px 100px white inset !important;
}
</style>
